import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall, FrappeDB } from 'frappe-js-sdk';
import { AppConstant } from '../../app.constant';

@Injectable({
    providedIn: 'root'
})
export class GrIrService {
    private frappe: FrappeApp;
    private frappeCall: FrappeCall;
    private db: FrappeDB;
    constructor() {
        this.frappe = new FrappeApp(AppConstant.frappeUrl);
        this.frappeCall = this.frappe.call()
        this.db = this.frappe.db()
    }

    public getGRList(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.gr-ir.get_all_gr');
    }

    public getGRLists(data:any): Promise<any> {
        return this.frappeCall.get('vendor_portal.rest.get_pageable_gr_list',{ data })
    }

    public getGRLineItem(data:any): Promise<any> {
        return this.frappe.call().get('vendor_portal.rest.get_pageable_gr_line_item',{data});
    }

    public getIRList(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.gr-ir.get_all_ir');
    }
    public getIRLists(data:any): Promise<any> {
        return this.frappeCall.get('vendor_portal.rest.get_pageable_ir_list',{ data })
    }


    public getPlantList(): Promise<any> {
        return this.db.getDocList("Plant", { "fields": ['*'] })
    }

    public downloadGrByDate(data:any): Promise<any> {
      return this.frappeCall.get('vendor_portal.rest.download_gr_by_date',{data:JSON.stringify(data)})
    }

    public downloadIrByDate(data:any): Promise<any> {
      return this.frappeCall.get('vendor_portal.rest.download_ir_by_date',{data:JSON.stringify(data)})
    }

}
